export const ACTIVATE_CARD = 'ACTIVATE_CARD';
export const SET_PIN = 'SET_PIN';

export const CVV_FIELD_NAME = 'data.attributes.cvv2';
export const EXPIRATION_DATE_FILED_NAME = 'data.attributes.expirationDate';
